import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  Radio,
  Typography,
  Alert,
  Spin,
  Descriptions,
} from "antd"
import { SendOutlined } from "@ant-design/icons"
import NumberFormat from "react-number-format"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import {
  getGasProjectInfoPublic,
  getPaymentMelliPublic,
  paymentIpgReset,
} from "store/actions"
import logoSm from "../../../assets/images/nazamlogo.png"


const PaymentPublic = props => {
  const query = new URLSearchParams(props.location.search)
  const {
    loading,
    loadingGasProject,
    gasProjectInfoPublic,
    onGetGasProjectInfoPublic,
  } = props
  const returnFromBank = query.get("result")
  const [returnMessage, setReturnMessage] = useState(null)

  useEffect(() => {
    const gasProjectId = query.get("g")
    if (!gasProjectId && !returnFromBank) {
      window.alert("مشکل در شماره پارامتر های ارسالی")
    } else {
      onGetGasProjectInfoPublic(gasProjectId)
    }
  }, [])

  useEffect(() => {
    if (returnFromBank) {
      if (returnFromBank.includes("ok"))
        setReturnMessage(
          `مبلغ به حساب کیف پول واحد گاز واریز گردید - کد رهگیری: ${
            returnFromBank.split("-")[1]
          }`
        )
      if (returnFromBank.includes("error")) setReturnMessage("واریز انجام نشد")
    }
  }, [])

  const sendToBank = () => {
    const gasProjectId = query.get("g")
    if (!gasProjectId || !gasProjectInfoPublic.amountPay) {
      window.alert("مشکل در شماره پارامتر های ارسالی")
    } else {
      props.onGetPaymentIpgPublic({
        gasProjectId,
        amount: gasProjectInfoPublic.amountPay,
      })
    }
  }

  return (
    <div style={{ maxWidth: 600, margin: "50px auto", padding: 20 }}>
      {(loading || loadingGasProject) && (
        <Spin size="large" style={{ width: "100%", marginBottom: 20 }} />
      )}

      {props.error && <Alert type="error" message={props.error} />}
      {returnMessage && <Alert type="info" message={returnMessage} />}
{gasProjectInfoPublic?.naCode}
      {!returnFromBank && gasProjectInfoPublic && (
        <Card
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                src={logoSm}
                alt="Logo"
                style={{ width: 50, marginRight: 10 }}
              />
              <span className="ps-4">واحد نظارت گاز رسانی سازمان نظام مهندسی استان کردستان</span>
            </div>
          }
          style={{ marginTop: 20 }}
        >
        <Alert
        type="error"
        message="مالک گرامی درصورت اطمینان از صحت اطلاعات زیر نسبت به پرداخت اقدام نمایید.
        پس از پرداخت هزینه امکان حذف پرونده یا بازپرداخت وجه آن وجود ندارد "
        ></Alert>
          <Descriptions bordered column={1} size="small">
            <Descriptions.Item label="نام مالک">
              {gasProjectInfoPublic.landlordName}
            </Descriptions.Item>
            <Descriptions.Item label="کد ملی مالک">
              {gasProjectInfoPublic.naCode}
            </Descriptions.Item>
            <Descriptions.Item label="تعداد واحد">
              {gasProjectInfoPublic.unitNumber}
            </Descriptions.Item>
            <Descriptions.Item label="طبقه">
              {gasProjectInfoPublic.floorNumber}
            </Descriptions.Item>

            <Descriptions.Item label="آدرس">
              {gasProjectInfoPublic.address}
            </Descriptions.Item>
            <Descriptions.Item label="مبلغ پرداختی">
              <NumberFormat
                value={gasProjectInfoPublic.amountPay}
                displayType="text"
                thousandSeparator
                suffix=" ریال"
              />
            </Descriptions.Item>
          </Descriptions>

          <Button
            type="primary"
            icon={<SendOutlined />}
            block
            style={{ marginTop: 20 }}
            onClick={sendToBank}
            loading={loadingGasProject}
          >
            ارسال به بانک
          </Button>
          <Descriptions bordered column={1} size="small">
            <Descriptions.Item label="نماد اعتماد">
              <a
                referrerPolicy="origin"
                target="_blank"
                href="https://trustseal.enamad.ir/?id=293437&Code=nHJ5DfcRppVkF57irimx"
              >
                <img
                  referrerPolicy="origin"
                  src="https://Trustseal.eNamad.ir/logo.aspx?id=293437&Code=nHJ5DfcRppVkF57irimx"
                  alt=""
                  style={{ cursor: "pointer", width: "200px" }}
                  id="nHJ5DfcRppVkF57irimx"
                />
              </a>
            </Descriptions.Item>
          </Descriptions>
        </Card>
      )}
    </div>
  )
}

const mapStateToProps = ({ Payment, GasProjects }) => ({
  paymentMelliUrl: Payment.paymentMelliUrl,
  error: Payment.error || GasProjects.error,
  success: Payment.success || GasProjects.success,
  loading: Payment.loading,
  loadingGasProject: GasProjects.loading,
  gasProjectInfoPublic: GasProjects.gasProjectInfoPublic,
})

const mapDispatchToProps = dispatch => ({
  onGetPaymentIpgPublic: data => dispatch(getPaymentMelliPublic(data)),
  onPaymentMelliReset: () => dispatch(paymentIpgReset()),
  onGetGasProjectInfoPublic: data => dispatch(getGasProjectInfoPublic(data)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(PaymentPublic))
